import { useState, useCallback } from 'react';

/**
 * Unified state management for wizard steps
 * @returns {object} Step state management functions and data
 */
export const useStepState = () => {
  const [stepStates, setStepStates] = useState({});

  const updateStepState = useCallback((stepKey, updates) => {
    setStepStates((prev) => ({
      ...prev,
      [stepKey]: { ...prev[stepKey], ...updates },
    }));
  }, []);

  const getStepState = useCallback(
    (stepKey) => {
      return stepStates[stepKey] || {};
    },
    [stepStates],
  );

  const resetStepState = useCallback((stepKey) => {
    setStepStates((prev) => {
      const newState = { ...prev };
      delete newState[stepKey];
      return newState;
    });
  }, []);

  return {
    stepStates,
    updateStepState,
    getStepState,
    resetStepState,
  };
};
